import { render, staticRenderFns } from "./NicheOrder.vue?vue&type=template&id=bc2e047a&scoped=true"
import script from "./NicheOrder.vue?vue&type=script&lang=js"
export * from "./NicheOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2e047a",
  null
  
)

export default component.exports